<template>
  <b-modal id="createLeaveGroupModal" :title="group ? 'Edit Leave Group' : 'Create Leave Group'" hide-footer no-close-on-backdrop @show="fetchLeaveTypes" @hidden="resetForm">
    <div class="loading" v-if="loading">
      <load-data></load-data>
    </div>

    <b-form v-else @submit.prevent="submit">
      <b-form-group label="Name" label-for="group-name">
        <b-form-input
          id="group-name"
          v-model="form.name"
          placeholder="Enter leave group name"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group label="Approval">
        <b-form-radio-group v-model="form.approval_level" stacked>
          <b-form-radio :value="1">Single level - the approver approves directly</b-form-radio>
          <b-form-radio :value="2">2 level - HOD recommends, then the approver approves</b-form-radio>
        </b-form-radio-group>
      </b-form-group>

      <div v-if="leaveTypes.length">
        <label class="font-weight-bold mt-2 mb-1">Leave Limits</label>
        <b-form-group
          v-for="leaveType in leaveTypes"
          :key="leaveType.id"
          :label="leaveType.name"
          :label-for="'limit-' + leaveType.id"
          label-cols="7"
          class="mb-1"
        >
          <!-- ticking NA makes the leave type unlimited, the count box then just shows NA -->
          <div class="d-flex align-items-center">
            <b-form-input
              v-if="form.unlimited[leaveType.id]"
              :id="'limit-' + leaveType.id"
              value="NA"
              disabled
            ></b-form-input>
            <b-form-input
              v-else
              :id="'limit-' + leaveType.id"
              v-model.number="form.leave_limits[leaveType.id]"
              type="number"
              min="0"
              required
            ></b-form-input>
            <b-form-checkbox
              v-model="form.unlimited[leaveType.id]"
              class="ml-2"
              style="white-space:nowrap"
              title="Unlimited leave"
            >NA</b-form-checkbox>
          </div>
        </b-form-group>
      </div>

      <div class="d-flex justify-content-end mt-3">
        <b-button variant="secondary" class="mr-2" @click="$bvModal.hide('createLeaveGroupModal')">Cancel</b-button>
        <b-button type="submit" variant="primary" :disabled="saving">{{ group ? 'Save' : 'Create' }}</b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import axios from "axios";

export default {
  props: {
    leaveCycleId: {
      type: [Number, String],
      default: null,
    },
    group: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      loading: false,
      saving: false,
      leaveTypes: [],
      form: {
        name: "",
        approval_level: 1,
        leave_limits: {},
        unlimited: {},
      },
    };
  },

  methods: {
    async fetchLeaveTypes() {
      this.loading = true;
      this.form.name = this.group ? this.group.name : "";
      this.form.approval_level = this.group && this.group.approval_level == 2 ? 2 : 1;

      const url = this.$store.getters.getAPIKey.mainAPI + `/faculty-leave-types`;
      await axios.get(url)
        .then((response) => {
          this.leaveTypes = response.data.data;
          const limits = {};
          const unlimited = {};
          this.leaveTypes.forEach((t) => {
            const existing = this.group
              ? (this.group.leave_types || []).find((l) => l.leave_type.id === t.id)
              : null;
            limits[t.id] = existing ? existing.max_leaves : 0;
            unlimited[t.id] = existing ? !!existing.is_unlimited : false;
          });
          this.form.leave_limits = limits;
          this.form.unlimited = unlimited;
        })
        .catch(() => {
          this.$toast.error("Failed to load leave types", { position: "top", duration: 3000 });
        });

      this.loading = false;
    },

    async submit() {
      this.saving = true;

      const isEdit = !!this.group;
      const url = this.$store.getters.getAPIKey.mainAPI + `/faculty-leave/group` + (isEdit ? `/${this.group.id}` : "");

      const request = isEdit
        ? axios.put(url, { name: this.form.name, approval_level: this.form.approval_level, leave_limits: this.leaveLimitsToSend(), unlimited: this.form.unlimited })
        : axios.post(url, { name: this.form.name, approval_level: this.form.approval_level, leave_cycle_id: this.leaveCycleId, leave_limits: this.leaveLimitsToSend(), unlimited: this.form.unlimited });

      await request
        .then(() => {
          this.$toast.success(isEdit ? "Leave group updated" : "Leave group created successfully", { position: "top", duration: 3000 });
          this.$bvModal.hide("createLeaveGroupModal");
          this.$emit(isEdit ? "updated" : "created");
        })
        .catch(() => {
          this.$toast.error(isEdit ? "Failed to update leave group" : "Failed to create leave group", { position: "top", duration: 3000 });
        });

      this.saving = false;
    },

    // NA (unlimited) leave types have no count, send 0 for them
    leaveLimitsToSend() {
      const limits = {};
      Object.keys(this.form.leave_limits).forEach((id) => {
        limits[id] = this.form.unlimited[id] ? 0 : this.form.leave_limits[id];
      });
      return limits;
    },

    resetForm() {
      this.form = { name: "", approval_level: 1, leave_limits: {}, unlimited: {} };
      this.leaveTypes = [];
    },
  },
};
</script>
